import React from "react";
import MasterData from "view/settings/masterdata/MasterData";
const HseData = () => {
   
    const sections = [
        { label: "Incident Status", value: "IncidentStatus", items: [] },
        { label: "Contractor Name", value: "ContractorName", items: [] },
        { label: "Type of Incident", value: "TypeofIncident", items: [] },
        { label: "Incident Severity Rating", value: "IncidentSeverityRating", items: [] },
        { label: "Verification Done By", value: "VerificationDoneBy", items: [] },
    ];
   

    return (
        <>
            <MasterData pageTitle="Incident" sections={sections} />
        </>

    );
};

export default HseData;